export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1400px] flex-col gap-xl px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',

	grid: 'grid grid-cols-1 gap-md xl:grid-cols-2',

	card: 'overflow-hidden rounded-lg border border-subtle bg-white',
	cardMuted: 'overflow-hidden rounded-lg border border-subtle bg-grey-25/50',
	cardDegraded: 'overflow-hidden rounded-lg border border-amber-100 bg-white',

	head: 'flex items-start gap-xs border-b border-subtle/60 px-md py-sm',
	mark: 'inline-flex h-[36px] w-[36px] shrink-0 items-center justify-center rounded-lg border border-purple-100 bg-purple-50 text-purple-700',
	markMuted:
		'inline-flex h-[36px] w-[36px] shrink-0 items-center justify-center rounded-lg border border-subtle bg-grey-50 text-subtle',
	name: 'text-[14px] font-semibold leading-none text-default',
	nameMuted: 'text-[14px] font-semibold leading-none text-subtle',
	roleLabel: 'text-[10px] font-medium uppercase tracking-wider text-subtle',
	tag: 'inline-flex items-center rounded border border-subtle bg-grey-25 px-3xs py-3xs text-[10px] font-mono leading-none text-default',

	pillUp: 'inline-flex items-center gap-3xs text-[12px] text-green-800',
	pillDegraded: 'inline-flex items-center gap-3xs text-[12px] text-amber-700',
	pillDown: 'inline-flex items-center gap-3xs text-[12px] text-red-700',
	pillMuted: 'inline-flex items-center gap-3xs text-[12px] text-subtle',
	dotSuccess: 'inline-block h-2xs w-2xs rounded-full bg-green-500',
	dotWarn: 'inline-block h-2xs w-2xs rounded-full bg-amber-500',
	dotDown: 'inline-block h-2xs w-2xs rounded-full bg-red-500',
	dotMuted: 'inline-block h-2xs w-2xs rounded-full bg-grey-400',
	checkMeta: 'mt-3xs text-[10px] tabular-nums text-subtle',

	metricsGrid: 'grid grid-cols-2 gap-px bg-grey-50 sm:grid-cols-3',
	metric: 'flex min-w-0 flex-col gap-3xs bg-white px-md py-sm',
	metricLabel: 'text-[10px] font-medium uppercase tracking-wider leading-none text-subtle',
	metricValue: 'text-[15px] font-semibold leading-tight tabular-nums text-default',
	metricUnit: 'text-[11px] font-normal text-subtle',
	metricSub: 'text-[10px] leading-tight text-subtle',

	meter: 'mt-3xs h-[4px] w-full overflow-hidden rounded-full bg-grey-50',
	meterFillOk: 'h-full rounded-full bg-green-500',
	meterFillWarn: 'h-full rounded-full bg-amber-500',
	meterFillDanger: 'h-full rounded-full bg-red-500',

	footerWarn: 'flex items-center gap-2xs border-t border-amber-100 bg-amber-50/60 px-md py-xs',
	footerWarnText: 'text-[11px] leading-tight text-amber-700',
	footerDown: 'flex items-center gap-2xs border-t border-red-100 bg-red-50/60 px-md py-xs',
	footerDownText: 'text-[11px] leading-tight text-red-700',
	footerMuted: 'flex items-center gap-2xs border-t border-subtle/60 px-md py-xs',
	footerMutedText: 'text-[11px] leading-tight text-subtle',

	reference: 'flex items-start gap-xs rounded-lg border border-subtle bg-grey-25/50 px-md py-sm',
};
